import { IKeyValueInterface } from './../../shared/config';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { EventViewerModel, EventViewerSearchModel } from './../models/event-viewer.model';
import { EventViewerService } from './../models/event-viewer.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-event-viewer',
  template: require('../views/event-viewer.component.html'),
  providers: [EventViewerService],
  styles: [
    `
      .truncate-event-data{
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .search-icon {
        color:#2ba2aa;
      }

      .form-control{
        padding: 5px;
      }
    `
  ]
})
export class EventViewerComponent implements OnInit, OnDestroy {
  sub: any;
  isLoading: boolean;
  apiErrorMsg: string;
  eventList: EventViewerModel[];
  jsonEventData: any;
  errorModel: IKeyValueInterface[];
  itemPerPageList: any;
  searchCategoryList: any;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  searchModel: EventViewerSearchModel;


  urlDefaultPage: string;
  searchLabel: string;

  @ViewChild('jsonDataPopup') public jsonDataPopup: any;

  constructor(private eventViewerService: EventViewerService
    , private authService: AuthService
    , private activeRoute: ActivatedRoute
    , private translate: TranslateService) {
  }

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.searchModel = new EventViewerSearchModel();
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";
    this.LoadSearchCategory();
    this.HandleParameter();
  }

  public HandleParameter() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        let filter = params['filter'] || '';
        let searchField = params['searchTerm'] || '';

        if (filter && searchField) {
          this.searchModel.filter = decodeURIComponent(filter);
          this.searchModel.searchField = decodeURIComponent(searchField);
          this.GetAuditLogTrailList();
        }
      });
  }

  public LoadSearchCategory() {
    this.searchCategoryList = [
      {
        Key: this.translate.instant('LblSelectFilter'),
        Value: '',
      },
      {
        Key: this.translate.instant('LblVehicle'),
        Value: 'VEHICLE',
      },
      {
        Key: this.translate.instant('LblOBU'),
        Value: 'OBU',
      },
      {
        Key: this.translate.instant('LblBooking'),
        Value: 'BOOKING',
      },
      {
        Key: this.translate.instant('LblPerson'),
        Value: 'PERSON',
      },
      {
        Key: this.translate.instant('LblAuditEntries'),
        Value: 'AUDIT',
      },
      {
        Key: this.translate.instant('LblSharedVehicleGroup'),
        Value: 'SVG',
      },
      {
        Key: this.translate.instant('LblCompany'),
        Value: 'COMPANY',
      },
      {
        Key: this.translate.instant('LblSubscription'),
        Value: 'SUBSCRIPTION',
      }
    ];
  }

  public GetAuditLogTrailList() {
    this.isLoading = true;
    this.eventViewerService.GetAuditLogTrailList(this.searchModel)
      .subscribe(
      (res: any) => {
        this.eventList = res.data;
        this.searchModel.totalItems = res.totalRecords;
        this.errorModel = typeof res.error != "string" ? res.error : null;
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public SearchCategoryOnChange() {
    console.log(this.searchModel.filter);
    let filter = this.searchModel.filter;
    if (filter == "VEHICLE" || filter == "OBU") {
      this.searchLabel = this.translate.instant('LblLicenceTag');
    }
    else if (filter == "BOOKING") {
      this.searchLabel = this.translate.instant('LblBookingReferenceId');
    }
    else if (filter == "PERSON" || filter == "AUDIT") {
      this.searchLabel = this.translate.instant('LblUserName');
    }
    else if (filter == "SVG") {
      this.searchLabel = this.translate.instant('LblSharedVehicleGroup') + " / " + this.translate.instant('LblInstance');
    }
    else if (filter == "COMPANY") {
      this.searchLabel = this.translate.instant('LblCompany') + " / " + this.translate.instant('LblInstance');

    }
    else if (filter == "SUBSCRIPTION") {
      this.searchLabel = this.translate.instant('LblSubscription');
    }
    else {
      this.searchLabel = ' ';
    }
  }

  public OnSearch() {
    this.searchModel.pageNo = 1;
    this.GetAuditLogTrailList();
  }

  public OnPageChanged(event: any): void {
    this.searchModel.pageNo = event.page;
    this.GetAuditLogTrailList();
  }

  public OnPagingChange(itemPerPage: any) {
    this.searchModel.pageNo = 1;
    this.searchModel.totalItems = 0;
    this.searchModel.record = itemPerPage;
    this.GetAuditLogTrailList();
  }

  public OnSort(sortName: string) {
    this.searchModel.sortType = sortName;
    this.searchModel.sortReverse = !this.searchModel.sortReverse;
    this.GetAuditLogTrailList();
  }

  public ViewJsonPopup(eventData: string) {
    this.jsonEventData = JSON.parse(eventData);
    this.jsonDataPopup.show();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/event-viewer/components/event-viewer.component.ts